import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { OfflineOperation, IdMapping } from 'src/app/models/offlineOperation.model';

export const UPDATE_CONNECTION_STATUS = 'UPDATE_CONNECTION_STATUS';
export const SYNC_OFFLINE_OPERATION = 'SYNC_OFFLINE_OPERATION';
export const SYNC_OFFLINE_OPERATION_SUCCESS = 'SYNC_OFFLINE_OPERATION_SUCCESS';
export const ADD_OFFLINE_OPERATION = 'ADD_OFFLINE_OPERATION';
export const RESET_OFFLINE_OPERATION = 'RESET_OFFLINE_OPERATION';
export const REMOVE_OFFLINE_OPERATION = 'REMOVE_OFFLINE_OPERATION';
export const remove = 'MARK_OPERATION_EXECUTED';
export const MARK_OPERATION_EXECUTED = 'MARK_OPERATION_EXECUTED';
export const MARK_OPERATION_EXECUTED_WITH_ERROR =
  'MARK_OPERATION_EXECUTED_WITH_ERROR';
export const EXECUTE_OPERATION = 'EXECUTE_OPERATION';
export const SYNC_DATA_DONE = 'SYNC_DATA_DONE';
export const UPDATE_SYNC = 'UPDATE_SYNC';
export const LOAD_APP_DATA = 'LOAD_APP_DATA';
export const SHOW_OFFLINE_DELETION_POPOVER = 'SHOW_OFFLINE_DELETION_POPOVER';
export const SHOW_OFFLINE_DELETION_POPOVER_SUCCESS = 'SHOW_OFFLINE_DELETION_POPOVER_SUCCESS';

export const updateConnectionStatus = createAction(
  UPDATE_CONNECTION_STATUS,
  props<{ isOnline: boolean; connectionQuality: 'good' | 'poor' | 'offline' }>()
);

export const loadAppData = createAction(LOAD_APP_DATA);

export const showOfflineDeletionPopOver = createAction(SHOW_OFFLINE_DELETION_POPOVER);
export const showOfflineDeletionPopOverSuccess = createAction(SHOW_OFFLINE_DELETION_POPOVER_SUCCESS);
export const syncData = createAction(SYNC_OFFLINE_OPERATION);
export const syncDataSuccess = createAction(SYNC_OFFLINE_OPERATION_SUCCESS);
export const addOfflineOperation = createAction(
  ADD_OFFLINE_OPERATION,

  props<{ operation: OfflineOperation }>()
);

export const resetOfflineOperation = createAction(RESET_OFFLINE_OPERATION);
export const executeOperation = createAction(
  EXECUTE_OPERATION,
  props<{ operation: OfflineOperation }>()
);
export const SyncDataDone = createAction(SYNC_DATA_DONE);

export const markOperationExecuted = createAction(
  MARK_OPERATION_EXECUTED,
  props<{ id: number; error: HttpErrorResponse; data: any; is_production_state: boolean }>()
);
export const markOperationExecutedWithError = createAction(
  MARK_OPERATION_EXECUTED_WITH_ERROR,
  props<{ id: number; error: HttpErrorResponse; data: any }>()
);
export const removeOfflineOperation = createAction(
  REMOVE_OFFLINE_OPERATION,
  props<{ id: string }>()
);

// Update existing offline operation (e.g., modify its form data/body without creating a new one)
export const UPDATE_OFFLINE_OPERATION = 'UPDATE_OFFLINE_OPERATION';
export const updateOfflineOperation = createAction(
  UPDATE_OFFLINE_OPERATION,
  props<{ id: string; updatedFormDataObject: Partial<OfflineOperation> }>()
);
export const UpdateSync = createAction(
  UPDATE_SYNC,
  props<{ data: any; offlineId: string; stateName: string }>()
);

// Nouvelles actions pour le mapping d'ID
export const ADD_ID_MAPPING = 'ADD_ID_MAPPING';
export const CLEAR_ID_MAPPINGS = 'CLEAR_ID_MAPPINGS';
export const REPLACE_TEMP_IDS = 'REPLACE_TEMP_IDS';

export const addIdMapping = createAction(
  ADD_ID_MAPPING,
  props<{ mapping: IdMapping }>()
);

export const clearIdMappings = createAction(CLEAR_ID_MAPPINGS);

export const replaceTempIds = createAction(
  REPLACE_TEMP_IDS,
  props<{ request: any }>()
);

